import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ValuationSubmission {
  registration: string;
  readsAs?: string;
}

@Component({
  selector: 'pla-plate-x-val-band',
  templateUrl: './plate-x-val-band.component.html',
  styleUrls: ['./plate-x-val-band.component.scss'],
})
export class PlateXValBandComponent {
  @Input() regPlaceholder: string = 'YOUR PLATE';
  @Input() readsPlaceholder: string = 'Reads as (optional)';
  @Input() ctaLabel: string = 'Value my plate';
  @Input() utilityText: string = 'Free \u00B7 no obligation';
  /** When true, render only the val-band shell with projected content (no form, no utility dot). */
  @Input() compose: boolean = false;

  @Output() valuationSubmitted = new EventEmitter<ValuationSubmission>();

  registration: string = '';
  readsAs: string = '';

  submit(): void {
    const reg = (this.registration || '').trim();
    if (!reg) {
      return;
    }
    const reads = (this.readsAs || '').trim();
    this.valuationSubmitted.emit({
      registration: reg.toUpperCase(),
      readsAs: reads ? reads : undefined,
    });
  }
}
